import axios from "axios";
import { url } from "../baseUrl";

export const SettingStore = {
  state: {
    setting_group: {
      switch_on: false,
      mysystem_email_check: false,
      custom_email_check: false,
      custom_email: "",
      custom_group_check: false,
      group_emails: []
    }
  },
  mutations: {
    getSettings(state, data) {
      state.setting_group.switch_on = data.auto_report;
      state.setting_group.mysystem_email_check = data.system;
      state.setting_group.custom_email_check = data.custom;
      state.setting_group.custom_email = data.custom_email;
      state.setting_group.custom_group_check = data.group;
      state.setting_group.group_emails = data.group_emails;
    },
    updateSettings(state, data) {
      state.setting_group.switch_on = data.auto_report;
      state.setting_group.mysystem_email_check = data.system;
      state.setting_group.custom_email_check = data.custom;
      state.setting_group.custom_email = data.custom_email;
      state.setting_group.custom_group_check = data.group;
      state.setting_group.group_emails = data.group_emails;
    }
  },
  actions: {
    getSettings(context) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/configuration/settings/",
          headers: {
            Authorization: "Token " + auth_token
          },
          method: "GET"
        })
          .then(response => {
            context.commit("getSettings", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    updateSettings(context, data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/configuration/settings/",
          headers: {
            Authorization: "Token " + auth_token
          },
          data: {
            auto_report: data.switch_on,
            system: data.mysystem_email_check,
            custom: data.custom_email_check,
            custom_email: data.custom_email,
            group: data.custom_group_check,
            group_emails: data.group_emails
          },
          method: "POST"
        })
          .then(response => {
            context.commit("updateSettings", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
